var _path, _path2;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Bulb = function Bulb(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M12 2a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1ZM4.893 4.893a1 1 0 0 1 1.414 0l.7.7a1 1 0 0 1-1.414 1.414l-.7-.7a1 1 0 0 1 0-1.414ZM19.107 4.893a1 1 0 0 1 0 1.414l-.7.7a1 1 0 1 1-1.414-1.414l.7-.7a1 1 0 0 1 1.414 0ZM2 12a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1ZM19 12a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1Z",
      fill: "none",
      className: "tw-fill-current"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.24 17.343a2.5 2.5 0 0 1 .422-.59 6 6 0 1 0-7.324 0 2.5 2.5 0 0 1 .422.59c.02.056.046.11.077.162a2.496 2.496 0 0 1 .174 1.349A1 1 0 0 0 9 19a3 3 0 1 0 6 0 .998.998 0 0 0-.01-.146 2.5 2.5 0 0 1 .174-1.35.988.988 0 0 0 .075-.16ZM12 8a4 4 0 0 0-2.412 7.191 1.023 1.023 0 0 1 .13.112 4.5 4.5 0 0 1 .57.697h3.424a4.5 4.5 0 0 1 .585-.71 1 1 0 0 1 .103-.09A4 4 0 0 0 12 8Zm.989 10H11.01c.038.35.035.705-.01 1.057a1 1 0 0 0 1.997 0 4.506 4.506 0 0 1-.01-1.057Z",
      fill: "none",
      className: "tw-fill-current"
    }))]
  });
};
export default Bulb;